import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import IconButtonLabel from './icon-button-label'
import { connect } from 'react-redux'
import { showError } from '../../store/actions/alerts'
import { trimmedString, isOdd } from '../../misc/utils'
import IconButton from './icon-button'
import * as fileUploadApi from '../../store/api/file-upload'
import Loading from './loading'
import { v4 as uuidv4 } from 'uuid'

const allowedFileTypes = [
    'xls',
    'xlsx',
    'doc',
    'docx',
    'ppt',
    'pptx',
    'pdf',
    'png',
    'jpg',
    'jpeg',
    'bmp',
    'zip',
    'rar',
    '7z',
    'txt',
]

export class AttachmentSection extends React.Component {
    static propTypes = {
        editMode: PropTypes.bool.isRequired,
        attachments: PropTypes.array.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            attachments: this.props.attachments || [],
        }
    }

    render() {
        return (
            <div className=" my-2">
                {this.props.editMode && (
                    <small className="text-secondary" rel="tooltip">
                        Max size: 20MB
                    </small>
                )}

                <div className="mx-2 my-2">
                    {this.props.attachments &&
                        this.props.attachments.length > 0 &&
                        this.props.attachments.map((att, ix) => (
                            <AttachmentRow
                                key={ix}
                                index={ix}
                                attachment={att}
                                onRemoveAttachment={
                                    this.props.onRemoveAttachment
                                }
                                editMode={this.props.editMode}
                            />
                        ))}
                    {this.props.editMode && (
                        <AttachmentRow
                            key={this.props.attachments.length}
                            index={this.props.attachments.length}
                            attachment={undefined}
                            otherAttachments={this.props.attachments.map(
                                (att) => att.name
                            )}
                            onAddAttachment={this.props.onAddAttachment}
                            editMode={this.props.editMode}
                        />
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    // uploading: state.attachments.uploading,
    // uploadedFileId: state.attachments.uploadedFileId,
    // uploadErrorMessage: state.attachments.uploadErrorMessage,
})

export default connect(mapStateToProps, {
    showError,
})(AttachmentSection)

class AttachmentRow extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            uploading: false,
            displayError: undefined,
        }

        this.inputReference = React.createRef()
    }

    onDownload = () => {
        fileUploadApi
            .downloadFile(this.props.attachment.url, this.props.attachment.name)
            .catch((err) => this.setState({ displayError: err }))
    }

    onRemoveFile = (fileId) => {
        // TODO DELETE FILE FROM S3
        this.props.onRemoveAttachment(this.props.attachment)
    }

    fileUploadAction = () => this.inputReference.current.click()

    validateAttachment = (file) => {
        if (this.props.otherAttachments.includes(file.name)) {
            this.setState({
                displayError: 'A file with this name already exists',
            })
            return false
        }

        // if (file.)

        return true
    }

    onAddAttachmentClick = (e) => {
        var file = e.target.files[0]
        if (!file) return

        if (!this.validateAttachment(file)) return

        // Upload file to S3 and get URL
        this.setState({ uploading: true, displayError: undefined }, () => {
            fileUploadApi
                .uploadFile(file, uuidv4().replace('-', ''))
                .then((downloadUrl) => {
                    const attatchmentObj = {
                        name: file.name,
                        url: downloadUrl,
                    }

                    // Pass the attachment object to the idea
                    // This will also unmount the component, so no need to reset state
                    this.props.onAddAttachment(attatchmentObj)
                })
                .catch((err) => {
                    this.setState({
                        attachment: undefined,
                        uploading: false,
                        displayError: err,
                    })
                })
        })
    }

    renderWithoutAttachment = () => {
        if (this.props.editMode)
            return (
                <>
                    <input
                        type="file"
                        hidden
                        ref={this.inputReference}
                        onChange={this.onAddAttachmentClick}
                        accept={allowedFileTypes.join(',.')}
                    />
                    <small className="mr-4">
                        <IconButtonLabel
                            onClick={this.fileUploadAction}
                            text="Add Attachment"
                            icon="paperclip"
                        />
                    </small>

                    {this.state.uploading && <Loading height={30} width={30} />}

                    {this.state.displayError && (
                        <small className="text-danger">
                            {this.state.displayError}
                        </small>
                    )}
                </>
            )
        // else
        //     return (
        //         <p>
        //             <small>No attachments.</small>
        //         </p>
        //     )
    }

    renderWithAttachment = () => {
        var attachementDate = moment(this.props.attachment.uploadDate)

        return (
            <>
                <div className="col-md-11 col-lg-4 mr-auto text-secondary">
                    <small className="mb-0">
                        {trimmedString(this.props.attachment.name, 40)}{' '}
                    </small>
                </div>

                <div className="col-sm-4 col-lg-4 text-secondary">
                    <small rel="tooltip" title={attachementDate.format('LLLL')}>
                        Uploaded {attachementDate.fromNow()}.
                    </small>
                </div>

                <div className="col-sm-1 text-secondary">
                    <IconButton icon="download" onClick={this.onDownload} />
                </div>

                {this.props.editMode && (
                    <div className="col-sm-1 text-secondary">
                        <IconButton icon="trash" onClick={this.onRemoveFile} />
                    </div>
                )}
            </>
        )
    }

    render() {
        const backgroundColor = isOdd(this.props.index)
            ? 'transparent'
            : 'var(--secondary-very-light)'
        const borderColor = isOdd(this.props.index)
            ? 'var(--secondary-very-light)'
            : 'var(--light-gray)'

        return (
            <>
                <div
                    className="row align-items-center justify-text-left "
                    style={{
                        backgroundColor: backgroundColor,
                        borderLeft: 'solid 2px',
                        borderLeftColor: borderColor,
                        paddingLeft: '30px',
                        height: '35px',
                    }}>
                    {this.props.attachment
                        ? this.renderWithAttachment()
                        : this.renderWithoutAttachment()}
                </div>
            </>
        )
    }
}
